import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Label = styled.div`
  margin-bottom: 32px;
`
export const ButtonSecondary = styled.button`
  ${mixins.cta.secondary()}
`
